export default {
    router18: {
        app: 'Agent',
        create: 'Create',
        interface: 'Publish',
        openInterface: 'Integrations',
        createApp: 'Create App',
        agent: 'Configuration',
        manage: 'Manage',
        myAccount: 'Account',
        chatManage: 'Chat Manage',
        clients: 'Clients',
        dataAnalysis: 'Analysis',
        configurationClient: 'Configure',
        knowledgeBase: 'Knowledge',
        fileManage: 'Files',
        fileImport: 'Import',
        retrievalTest: 'Retrieval Test',
        knowledgeBaseConfig: 'Settings',
        mediaResource: 'Media',
        database: 'Database',
        dataPreview: 'Data',
        tableConfig: 'Tables',
        databaseConfig: 'Settings',
        plugins: 'Plugins',
        discovery: 'Discovery',
        templateCenter: 'Templates',
        templateDetail: 'Template Detail',
        workflow: 'Workflow',
        customPlugin: 'Create Plugin',
        teamSpace: 'Team',
        purchase: 'Purchase',
        customerManage: 'Customer Manage',
        customerList: 'Customer List',
        tagList: 'Tag List'
    }
}